import React, {useEffect, useState} from 'react';
import {
  Alert,
  Image,
  PermissionsAndroid,
  Platform,
  Text,
  View,
} from 'react-native';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import Input from '../../../../components/Input/Input';
import {Images} from '../../../../constants/Images';
import {styles} from './styles';
import {launchCamera, launchImageLibrary} from 'react-native-image-picker';
import ProfileService from '../../../../services/ProfileService/ProfileService';
import {useUserStore} from '../../../../store/UserStore';
import { masks } from '../../../../utils/mask';

interface IGeneralScreen {
  clientData?: IGeneral;
}
interface LocalClientData extends IGeneral {
  deliveryDay?: { day?: string };
}

const General = ({clientData}: IGeneralScreen) => {
  const localClientData = clientData as LocalClientData;
  // const [newPic, setNewPic] = useState(clientData?.profile);
  const {user} = useUserStore();

  // const requestCameraPermission = async () => {
  //   if (Platform.OS === 'android') {
  //     try {
  //       const granted = await PermissionsAndroid.request(
  //         PermissionsAndroid.PERMISSIONS.CAMERA,
  //         {
  //           title: 'Permissão para acessar a câmera',
  //           message:
  //             'Este aplicativo precisa de acesso à câmera para tirar fotos.',
  //           buttonNeutral: 'Pergunte-me depois',
  //           buttonNegative: 'Cancelar',
  //           buttonPositive: 'OK',
  //         },
  //       );
  //       if (granted === PermissionsAndroid.RESULTS.GRANTED) {
  //         console.log('Permissão para usar a câmera concedida');
  //       } else {
  //         console.log('Permissão para usar a câmera negada');
  //       }
  //     } catch (err) {
  //       console.warn(err);
  //     }
  //   } else {
  //     const permission = await PermissionsAndroid.request(
  //       PermissionsAndroid.PERMISSIONS.CAMERA,
  //     );
  //     if (permission === PermissionsAndroid.RESULTS.GRANTED) {
  //       console.log('Permissão para usar a câmera concedida no iOS');
  //     } else {
  //       console.log('Permissão para usar a câmera negada no iOS');
  //     }
  //   }
  // };

  // const requestPhotoLibraryPermission = async () => {
  //   if (Platform.OS === 'android') {
  //     try {
  //       const granted = await PermissionsAndroid.request(
  //         PermissionsAndroid.PERMISSIONS.READ_EXTERNAL_STORAGE,
  //         {
  //           title: 'Permissão para acessar a galeria',
  //           message:
  //             'Este aplicativo precisa de acesso à galeria para escolher fotos.',
  //           buttonNeutral: 'Pergunte-me depois',
  //           buttonNegative: 'Cancelar',
  //           buttonPositive: 'OK',
  //         },
  //       );
  //       if (granted === PermissionsAndroid.RESULTS.GRANTED) {
  //         console.log('Permissão para acessar a galeria concedida');
  //       } else {
  //         console.log('Permissão para acessar a galeria negada');
  //       }
  //     } catch (err) {
  //       console.warn(err);
  //     }
  //   } else {
  //     const permission = await PermissionsAndroid.request(
  //       PermissionsAndroid.PERMISSIONS.LIBRARY,
  //     );
  //     if (permission === PermissionsAndroid.RESULTS.GRANTED) {
  //       console.log('Permissão para acessar a galeria concedida no iOS');
  //     } else {
  //       console.log('Permissão para acessar a galeria negada no iOS');
  //     }
  //   }
  // };

  // const openCameraWithPermission = async () => {
  //   await requestCameraPermission();
  //   openCamera();
  // };

  // const openGalleryWithPermission = async () => {
  //   await requestPhotoLibraryPermission();
  //   openGallery();
  // };

  // const openCamera = () => {
  //   const options = {
  //     mediaType: 'photo',
  //     cameraType: 'back',
  //   };

  //   launchCamera(options, response => {
  //     if (response.didCancel) {
  //       console.log('User cancelled image picker');
  //     } else if (response.errorCode) {
  //       console.log('ImagePicker Error: ', response.errorMessage);
  //     } else {
  //       console.log('Imagem capturada: ', response.assets[0].uri);
  //       setNewPic(response.assets[0].uri);
  //       Alert.alert('Conecta Brasal', 'Deseja salvar a foto?', [
  //         {
  //           text: 'Sim',
  //           onPress: () => uploadImage(response.assets[0]),
  //         },
  //         {
  //           text: 'Não',
  //           onPress: () => null,
  //         },
  //       ]);
  //     }
  //   });
  // };

  // const openGallery = () => {
  //   const options = {
  //     mediaType: 'photo',
  //   };

  //   launchImageLibrary(options, response => {
  //     if (response.didCancel) {
  //       console.log('User cancelled image picker');
  //     } else if (response.errorCode) {
  //       console.log('ImagePicker Error: ', response.errorMessage);
  //     } else {
  //       console.log('Imagem selecionada: ', response.assets[0]);
  //       uploadImage(response.assets[0]);
  //     }
  //   });
  // };

  // const uploadImage = async image => {
  //   const formData = new FormData();
  //   formData.append('image', {
  //     uri: image.uri,
  //     type: image.type,
  //     name: image.fileName,
  //   });

  //   try {
  //     const response = await ProfileService.updatePicture(
  //       formData,
  //       user?.clientCode,
  //     );
  //     const jsonResponse = JSON.stringify(response);
  //     console.log(jsonResponse);
  //     Alert.alert(response.details);
  //   } catch (error) {
  //     console.error('Erro ao enviar a imagem: ', error);
  //   }
  // };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Geral</Text>
      {/* <Image
        source={newPic ? {uri: newPic} : Images.bear}
        style={styles.image}
      />
      <Text style={styles.imageSize}>
        Permitido JPG, GIF ou PNG com tamanho máximo de 800KB.
      </Text>
      <View style={styles.containerButton}>
        <ButtonComponent
          title="Remover"
          outlined
          width="42%"
          onPress={() =>
            Alert.alert(
              'Conecta Brasal',
              'Certeza que deseja remover a foto?',
              [
                {
                  text: 'Sim',
                  onPress: () => uploadImage(null),
                },
                {
                  text: 'Não',
                  onPress: () => null,
                },
              ],
            )
          }
        />
        <ButtonComponent
          title="Atualizar"
          width="42%"
          onPress={openCameraWithPermission}
        />
      </View> */}
      <View style={styles.containerInput}>
        <Input
          title="Usuário"
          placeholder="Usuário..."
          keyboardType="numeric"
          value={user?.current_client.name}
          // editable={false}
        />
        <Input
          title="E-mail"
          placeholder="E-mail..."
          keyboardType="numeric"
          mt={10}
          // editable={false}
          value={localClientData?.email}
        />
        <Input
          title="Telefone"
          placeholder="(99)99999-9999"
          keyboardType="numeric"
          mt={10}
          editable={false}
          value={ masks.maskPhone(user?.phone)}
        />
        <Input
          title="CPF/CNPJ"
          placeholder="CPF/CNPJ..."
          keyboardType="numeric"
          mt={10}
          // editable={false}
          value={user?.current_client?.cnpj_cpf}
        />
        {!!localClientData?.deliveryDay?.day && <Input
          title="Dia de Entrega de Pedidos"
          placeholder=""
          keyboardType="numeric"
          mt={10}
          // editable={false}
          value={localClientData?.deliveryDay?.day}
        />}
      </View>
    </View>
  );
};

export default General;
